var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-control-input__icon d-control-input__icon--prepend",class:_vm.prependIcon,on:{"click":function($event){$event.preventDefault();return _vm.prependIconFunc.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }